import "./faqPage.scss"
import { FaqSection, MainTitle } from '../../components'
import { Effect } from '../../assets/svgIcon/customIcon'
import { useTranslation } from 'react-i18next'

const FaqPage = () => {

  const { t } = useTranslation();

  return (
    <div className='faq-page'>
      <div className="container">
        <div className='row'>
          <div className="offset-xl-1 offset-lg-0 col-xl-10 col-lg-12">
            <div className='section-space'>
              <div className='effect-add-section'>
                <Effect className='effect-img' />
                <div className='faq-title-sec'>
                  <MainTitle mainText={`${t('faqs')}`} />
                  {/* <Link to={"#"} className='more-help'>{t('need-more-help')} <HelpCircle /></Link> */}
                </div>
                <FaqSection />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}

export default FaqPage